import React, { useState, useEffect } from 'react';
import GetMonths from '../../Dropdowns/getMonths';
import GetYears from '../../Dropdowns/getYears';
import Portability_Drawl_District from './Portability_Drawl_District';
import progressGif from "../../images/progress.gif";

const Portability_Drawl_Int = ({ heading }) => {
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [excludeFpsId, setExcludeFpsId] = useState(''); 
    const [loadingMonths, setLoadingMonths] = useState(true); 
    const [loadingYears, setLoadingYears] = useState(true);   
    const [showTable, setShowTable] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false); 

    const handleMonthsLoadingChange = (isLoading) => setLoadingMonths(isLoading);
    const handleYearsLoadingChange = (isLoading) => setLoadingYears(isLoading);

    const handleSubmit = () => {
        const month = document.getElementById('month').value;
        const year = document.getElementById('year').value;

        if (!month || month === '0') {
            alert('Please select Month');
            return;
        }
        if (!year || year === '0') {
            alert('Please select Year');
            return;
        }

        setSelectedMonth(month);
        setSelectedYear(year);
        setSubmitLoading(true);

        setTimeout(() => {
            setSubmitLoading(false);
            setShowTable(true);
        }, 3000);
    };

    const handleBack = () => {
        setSelectedMonth(null);
        setSelectedYear(null);
        setShowTable(false);
        setSubmitLoading(false);
    };

    return (
        <>
            <div className="wrapper row3">
                <div id="container">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <table width="50%">
                            <thead>
                                <tr className="tableheader">
                                    <th colSpan={8}>{heading}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Month</td>
                                    <td><GetMonths onLoadingChange={handleMonthsLoadingChange} /></td>
                                    <td>Year</td>
                                    <td><GetYears onLoadingChange={handleYearsLoadingChange} /></td>
                                </tr>
                                <tr>
                                    <td colSpan={8} align="center">
                                        <button 
                                            onClick={handleSubmit} 
                                            className="button button2" 
                                            disabled={loadingMonths || loadingYears || submitLoading}
                                        >
                                            Submit
                                        </button>
                                        <button 
                                            onClick={handleBack} 
                                            className="button button2"
                                        >
                                            Back
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <br />

                    {submitLoading && (
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                            <img src={progressGif} alt="Loading..." width="250" height="15" />
                        </div>
                    )}

                    <br />
                    {showTable && selectedMonth && selectedYear && !submitLoading && (
                        <Portability_Drawl_District 
                            month={parseInt(selectedMonth)} 
                            year={parseInt(selectedYear)} 
                            excludeFpsId={excludeFpsId}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default Portability_Drawl_Int;
